module.exports = __webpack_public_path__ + "static/img/website-analysis.e4c6c655.jpg";